import lotsBasicDataMulti from './index.vue'; // 导入组件

lotsBasicDataMulti.install = (Vue) => {
    Vue.component(lotsBasicDataMulti.name, lotsBasicDataMulti);
};
export default lotsBasicDataMulti;
